export default __webpack_public_path__ + "static/play-icon-3bb7c07a81990b138e0530b419a8a513.svg";